/* eslint-disable linebreak-style */
/* eslint-disable import/extensions */
/* eslint-disable react/jsx-filename-extension */
import React, { Component } from 'react';

import Header from 'parts/Header';
import Hero from 'parts/Hero';
import ServicesNumbered from 'parts/ServicesNumbered';
import Capabilities from 'parts/Capabilities';
import Mission from 'parts/Mission';
import Stats from 'parts/Stats';
import SingleTestimonial from 'parts/SingleTestimonial';
import DiscussProject from 'parts/DiscussProject';
import Footer from 'parts/Footer';

import {
  Services,
  Capabilities as CapabilitiesData,
  Mission as MissionData,
  Stats as StatsData,
  Testimonials,
} from 'json/landingPageData';

export default class LandingPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div className="neon-theme">
        <Header />
        <Hero />
        <ServicesNumbered data={Services} />
        <Capabilities data={CapabilitiesData} />
        <Mission data={MissionData} />
        <Stats data={StatsData} />
        <SingleTestimonial data={Testimonials[0]} />
        <DiscussProject />
        <Footer />
      </div>
    );
  }
}
